import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import ChartistGraph from "react-chartist";
import Chartist from "chartist";

const styles = {};

const delays = 80,
  durations = 500;
function AnimatedPieChart(props) {
  const low = Math.min(...props.series) - 3;
  const high = Math.max(...props.series) + 3;
  const dailySalesChart = {
    data: {
      labels: props.labels,
      series: [props.series.map(v => -v)]
    },
    options: {
      height: "200px",
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      low: -high,
      high: -low,
      chartPadding: {
        top: 0,
        right: 5,
        bottom: 40,
        left: -15
      }
    },
    // for animation
    animation: {
      draw: data => {
        if (data.type === "line" || data.type === "area") {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path
                .clone()
                .scale(1, 0)
                .translate(0, data.chartRect.height())
                .stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === "point") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: "ease"
            }
          });
        }
      }
    }
  };

  return (
    <ChartistGraph
      className="ct-chart"
      data={dailySalesChart.data}
      type="Line"
      options={dailySalesChart.options}
      listener={dailySalesChart.animation}
    />
  );
}
AnimatedPieChart.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AnimatedPieChart);
